import i18n from '../i18n';

export function getTranslatedNotification(notification, t) {
  if (!notification) return { title: '', message: '' };

  const rawTitle = notification.title || notification.Title || '';
  const rawMessage = notification.message || notification.Message || '';

  let title = rawTitle;
  if (rawTitle && i18n.exists(rawTitle)) {
    title = t(rawTitle);
  }

  let message = rawMessage;
  if (rawMessage) {
    if (typeof rawMessage === 'string' && rawMessage.trim().startsWith('{')) {
      try {
        const parsed = JSON.parse(rawMessage);
        if (parsed && parsed.key) {
          message = t(parsed.key, parsed.params || {});
        }
      } catch (e) {
        // Fallback to raw message if parsing fails
      }
    } else if (i18n.exists(rawMessage)) {
      message = t(rawMessage);
    }
  }

  return { title, message };
}
